import {DeviceType} from '../../incase-domain/common/DeviceType.enum';
import {LayoutReducerType, SET_DESKTOP_VIEW_SELECTED, SET_FULLSCREEN, SET_SELECTED_DEVICE_TYPE} from '../actions/types/layout.action.types';

export interface LayoutReducerState {
    isSidebarCollapsed: boolean;
    isDesktopViewSelected: boolean;
    isFullScreen: boolean;
    selectedDeviceType: DeviceType;
}

export const preloadedState: LayoutReducerState = {
    isSidebarCollapsed: false,
    isDesktopViewSelected: false,
    isFullScreen: false,
    selectedDeviceType: DeviceType.DESKTOP,
};

export const layoutReducer = (state: LayoutReducerState = preloadedState, action: LayoutReducerType): LayoutReducerState => {
    switch (action.type) {
        case SET_DESKTOP_VIEW_SELECTED:
            return {...state, isDesktopViewSelected: action.payload};
        case SET_FULLSCREEN:
            return {...state, isFullScreen: action.payload};
        case SET_SELECTED_DEVICE_TYPE:
            return {...state, selectedDeviceType: action.payload};
        default:
            return state;
    }
};
